export class ExpensesLogisticsUpdateDto {

    expensesLogisticsId?: number;
    fdaDueDate?: string;
    remarks?: string;
    createdUser:string;
    updatedUser:string;
    isActive:boolean;
    
    constructor(
        expensesLogisticsId?: number,
    fdaDueDate?: string,
    remarks?: string,
    createdUser?:string,
    updatedUser?:string,
    isActive?:boolean,
            )
            {
           this.expensesLogisticsId=expensesLogisticsId
           this.fdaDueDate=fdaDueDate
           this.remarks=remarks
           this.createdUser=createdUser
           this.updatedUser=updatedUser
           this.isActive=isActive
        }
}

